import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import PropTypes from 'prop-types';

const ErrorDialog = ({ message, onRequestClose, title = "Something went wrong"}) => (
  <Dialog
    open={!!message}
    actions={<FlatButton
      label="OK"
      primary={true}
      keyboardFocused={true}
      onTouchTap={onRequestClose}
    />}
    onRequestClose={onRequestClose}
    title={title}
    modal={false}
  >
    {message}
  </Dialog>
);

ErrorDialog.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
  onRequestClose: PropTypes.func.isRequired,
}

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/components/ErrorDialog/index.jsx